import React from "react";
import {observer} from "mobx-react";
import includes from "lodash/includes";
import isNil from "lodash/isNil";
import globals from "../../util/globals";
import PropTypes from "prop-types";
import Propulator from "../../higher-order/Propulator";

const getChatbotEnv = (environment) => {
    let env;
    if (typeof window !== "undefined") {
        env = globals.get("environment");
    } else {
        env = environment;
    }
    env = (env || "LOCAL").toUpperCase();
    const isNotProd = includes(["LOCAL", "TESTING", "DEVELOPMENT", "STAGING"], env);
    return isNotProd ? "qa" : "prod";
};

@observer
class Chatbot extends React.Component {
    static propTypes = {
        isEmployer: PropTypes.bool.isRequired,
        environment: PropTypes.string,
        session: PropTypes.object
    };

    shouldRenderChatbot() {
        const {session, isEmployer} = this.props;
        if (isNil(session)) {
            return false;
        }
        const chatbotToggle = session?.featureToggles?.chatbotToggle ?? false;
        const isLoggedIn = session?.isLoggedIn ?? false;
        return isLoggedIn && chatbotToggle && !isNil(isEmployer);
    }

    render() {
        const {
            isEmployer,
            environment
        } = this.props;

        const env = getChatbotEnv(environment);

        if (!this.shouldRenderChatbot()) {
            return null;
        }

        return (
            <div
                style={{
                    position: "fixed",
                    bottom: 20,
                    right: 20,
                    zIndex: 100,
                }}
            >
                <vestwell-help-center
                    env={env}
                    plans="gradifi"
                    entities={isEmployer === true ? "employer" : "saver"}
                />
            </div>
        );
    }
}

export default Propulator(Chatbot, {
    sessionStore: [
        "environment",
        "session"
    ]
});
